import { jsx as _jsx } from "react/jsx-runtime";
import NoCertificatesContainer from './subcomponents';
import ShopMore from '../ShopMore';
var NoCertificates = function () {
    return (_jsx(NoCertificatesContainer, { children: _jsx(ShopMore, {}) }));
};
export default NoCertificates;
